export default __webpack_public_path__ + "images/command_key-1MvIm.png";